<template>
  <div>
    <ValidationProvider
      v-slot="{ errors }"
      :name="$t('login.create_account.data_protection_agreement')"
      rules="required"
      slim
    >
      <div
        class="alert alert-warning data-protection-agreement"
        :class="{'has-error': errors.length}"
      >
        <p class="info">
          {{ $t('login.create_account.data_protection_info') }}
          <a
            target="_blank"
            class="link"
            :href="data_protection_url"
            :aria-label="$t('login.create_account.data_protection_info')"
          >
            LINK
          </a>
        </p>
        <div>
          <input
            id="dataProtectionCheckbox"
            ref="input"
            type="checkbox"
            name="data-protection-checkbox"
            style="vertical-align: middle; margin-top: 0;"
            :value="value"
            :disabled="processingForm"
            @change="update(value)"
          >
          <label
            for="dataProtectionCheckbox"
          >
            {{ $t('login.create_account.data_protection_label') }}
          </label>
        </div>
        <span
          class="help-block"
          role="alert"
        >
          <i
            v-if="errors.length"
            class="fa fa-warning"
          />{{ errors[0] }}
        </span>
      </div>
    </ValidationProvider>
  </div>
</template>

<script>
import {ValidationProvider, extend} from 'vee-validate'
import {required} from 'vee-validate/dist/rules'
import json from '@/configuration.json'

extend('required', required)
export default {
  name: 'Privacy',
  components: {ValidationProvider},
  props: {
    value: {
      type: String,
      required: true
    },
    processingForm: {
      type: Boolean,
      default: false
    },
  },
  data(){
    return{
      checkbox: false,
      data_protection_url: json.gdpr_urls.data_protection_url
    }
  },
  methods: {
    update(value) {
      if(!value){
        this.$emit('input', 'agreement')
      } else
        this.$emit('input', '')
    }
  }
}
</script>
